export const SET_STRIPE = 'SET_STRIPE';
export const CREATE_STRIPE_SOURCE = 'CREATE_STRIPE_SOURCE';
export const UPDATE_STRIPE_SOURCE = 'UPDATE_STRIPE_SOURCE';
export const SET_STRIPE_ERROR = 'SET_STRIPE_ERROR';
export const CLEAR_STRIPE_ERROR = 'CLEAR_STRIPE_ERRROR';
export const REGISTER_CONTRACT_ID = 'REGISTER_CONTRACT_ID';
export const CLEAR_CONTRACT_ID_ERROR = 'CLEAR_CONTRACT_ID_ERROR';
export const SET_CONTRACT_ID_ERROR = 'SET_CONTRACT_ID_ERROR';
